
<app-filter-results [filterBy]="filterBy" [isFilterInAvailable]="true"
[searchBy]="searchBy" [isSearchingAvailable]="true" (onApplyFilter)="applyFilter($event)"
(resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)"></app-filter-results>